module.exports = __webpack_public_path__ + "img/groupBackgroundImg.53921844.png";